import React from "react";
import { Agency, AgencyId, AgencyMemberId } from "../../messages";
import { AgencyWithChatOnlyDetails } from "../../system/AppState/AppAgenciesState";
import { HashMap } from "../../utils/HashMap";
import AgenciesList from "./AgenciesList";
import { AgencyMembershipStatus } from "./AgenciesListUtils";

interface Props {
  agencies: HashMap<AgencyId, AgencyWithChatOnlyDetails>;
  onClickChatWithAgencyMember: (agencyMemberId: AgencyMemberId) => void;
  onClickChatWithMedflytAgency: () => void;
  onClickCancelAgency: (agencyId: AgencyId) => void;
}

const AgenciesListActivity = (props: Props) => {
  const [selectedAgencyId, setSelectedAgencyId] = React.useState<AgencyId>();
  const [selectedDepartment, setSelectedDepartment] = React.useState<string>();
  const [activeTab, setActiveTab] = React.useState<AgencyMembershipStatus>("Active");
  const [agencyIdToCancel, setAgencyIdToCancel] = React.useState<AgencyId>();

  const handleRequestCloseChatWithAgency = React.useCallback(() => {
    setSelectedAgencyId(undefined);
  }, []);

  const onRequestCloseCancelRequestPrompt = React.useCallback(() => {
    setAgencyIdToCancel(undefined);
  }, []);

  const handleClickOpenCancelPrompt = React.useCallback((agencyId: AgencyId) => {
    setAgencyIdToCancel(agencyId);
  }, []);

  const handleClickSetActiveAgency = React.useCallback(
    (agency: Agency) => {
      if (agency.isMedflytAgency) {
        props.onClickChatWithMedflytAgency();
      } else {
        setSelectedAgencyId(agency.id);
      }
    },
    [props]
  );

  return (
    <AgenciesList
      agencies={props.agencies}
      selectedAgencyId={selectedAgencyId}
      selectedDepartment={selectedDepartment}
      activeTab={activeTab}
      agencyIdToCancel={agencyIdToCancel}
      onRequestCloseChatWithAgency={handleRequestCloseChatWithAgency}
      onRequestCloseCancelRequestPrompt={onRequestCloseCancelRequestPrompt}
      onClickOpenCancelPrompt={handleClickOpenCancelPrompt}
      onClickDepartment={setSelectedDepartment}
      onClickTab={setActiveTab}
      onClickChatWithAgency={handleClickSetActiveAgency}
      onClickChatWithAgencyMember={props.onClickChatWithAgencyMember}
      onClickCancel={props.onClickCancelAgency}
    />
  );
};

export default React.memo(AgenciesListActivity);
